import { Paper, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';

interface BaseWidgetProps {
    children: React.ReactNode;
    elevation?: number;
    sx?: object;
}

export const BaseWidget: React.FC<BaseWidgetProps> = ({ children, elevation = 2, sx = {} }) => {
    const theme = useTheme();
    const isLargeScreen = useMediaQuery('(min-width:700px)');
    const padding = isLargeScreen ? '24px' : '16px';

    return (
        <Paper
            elevation={elevation}
            sx={{
                borderRadius: theme.shape.borderRadius,
                width: '100%',
                maxWidth: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                boxSizing: 'border-box',
                overflow: 'hidden',
                transition: 'all 0.3s ease',
                mb: 2,
                // Responsive padding for direct children
                '& > *': {
                    padding: padding,
                },
                // Mobile responsive fixes
                [theme.breakpoints.down('sm')]: {
                    mx: 0,
                    width: '100%',
                    maxWidth: '100%',
                    minWidth: 0,
                    '&:hover': {
                        transform: 'none', // Disable hover transform on mobile
                    },
                },
                '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: theme.shadows[8],
                    [theme.breakpoints.down('sm')]: {
                        transform: 'none',
                    },
                },
                ...sx,
            }}
        >
            {children}
        </Paper>
    );
};
